export default function slugify(str, options = {}) {
	if (!str || typeof str !== 'string') {
		return str;
	}
	if (options.replaceAccentedChars) {
		str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}
	return str.normalize().replace(/[^\w\s$*_+~.()'"!\-:@]+/g, '').trim().replace(/\s+/g, '-').toLowerCase();
}